import { render, staticRenderFns } from "./bindingCard.vue?vue&type=template&id=100dba73&scoped=true&"
import script from "./bindingCard.vue?vue&type=script&lang=js&"
export * from "./bindingCard.vue?vue&type=script&lang=js&"
import style0 from "./bindingCard.vue?vue&type=style&index=0&id=100dba73&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100dba73",
  null
  
)

export default component.exports